<template>
  <v-container v-if="report">
    <GoBackAtTop
      :to="{
        name: 'InstructorApprenticesReports',
        params: {id: currentUser.id, apprenticeModel: $route.params.apprenticeModel}
      }"
      :label="$t('labels.reports')"
    />

    <div class="title-icon">
      <h1>{{ $t('ebook.report') }}</h1>
      <v-btn icon :href="links.ebook.instructorInfo" target="_blank">
        <v-icon>$sl-question</v-icon>
      </v-btn>
    </div>

    <MessageBox v-if="!instructorBelongsToReport" type="alert" class="mt-2 mb-6">
      <p>{{ $t('ebook.instructor.warning-text') }}</p>
    </MessageBox>

    <template v-if="shouldReadInstructions && report && report.instructor &&
                report.instructor.companyId && isInstructor(report.instructor.companyId) == true">
      <MessageBox class="mt-5" type="warning">
        <h6>{{ $t("settings.no-readInstructions-mb-title") }}</h6>
        <p v-html="$t('settings.no-readInstructions-mb-text')"></p>
    </MessageBox>    
    </template>
    <template v-else>
      <h4 class="mb-1">{{ $t('labels.time-location') }}</h4>
      <!-- Instructor -->
      <template v-if="report && report.instructor && report.instructor.employed">
        <div v-if="report && report.instructor && report.instructor.employed" class="title-icon mt-4">
          <div class="overline">{{ $t('labels.instructor') }}</div>
          <v-icon v-if="edit == true" @click="instructorModal = true">$sl-edit</v-icon>
        </div>
        <p>{{ report.instructor.employed | fullName }}</p>
      </template>

      <!-- TIME : From date to date -->
      <div class="title-icon mt-6">
        <div class="overline">{{ $t('labels.time') }}</div>
        <v-icon v-if="edit" @click="openDates">$sl-edit</v-icon>
      </div>
      <div class="d-flex" v-if="report.fromDate == report.toDate">
        <div>{{ $t('labels.date') }}:</div>
        <div class="pl-12">{{ report.fromDate | date }}</div>
      </div>
      <div v-else>
        <p class="mb-1">{{ $t('labels.from') }}: {{ report.fromDate | date }}</p>

        <p>{{ $t('labels.to') }}: {{ report.toDate | date }}</p>
      </div>

      <!-- workplace -->
      <div class="title-icon mt-6">
        <div class="overline">{{ $t('labels.workplace') }}</div>
        <v-icon v-if="edit" @click="workplaceModal = true">$sl-edit</v-icon>
      </div>
      <p>{{ workplace }}</p>

      <!-- Delmoment starts here -->

      <h4 v-if="report && report.reportDetails" class="mt-8">{{ $t('ebook.elementpart') }}</h4>

      <v-list one-line class="skills mt-4" v-if="report && report.reportDetails">
        <v-card class="mb-4" flat v-for="(item, index) in report.reportDetails" :key="index">
          <v-list-item :class="`skill${apprenticeOrInstructorLevel(item)}`">
            <v-icon
              v-if="apprenticeOrInstructorLevel(item) > 0 && apprenticeOrInstructorLevel(item) < 5"
              class="skill-level"
              >$sl-ebook-lvl{{ apprenticeOrInstructorLevel(item) }}</v-icon
            >

            <v-icon class="skill-level" v-else></v-icon>

            <v-list-item-content class="ml-2 d-flex align-center">
              <div class="overline regular">{{ Lget(item, 'subElement.element.name', '') }} > {{ Lget(item, 'subElement.name', '') }}</div>
              <div class="medium" v-if="Lget(item, 'apprenticeComment', null)">{{ Lget(item, 'apprenticeComment', '') | comment }}</div>
            </v-list-item-content>

            <template v-if="Lget(report, 'instructor.companyId', false) && currentUserIsInstructorFor(Lget(report, 'instructor.companyId', -1)) == true">
              <v-btn
                v-if="!item.instructorSkillEstimatedLevel"
                class="elevation font-weight-bold"
                color="primary"
                :style="{ height: '40px' }"
                @click="$nextTick(() => {
                  $router.push({
                    name: 'InstructorApprenticesReportDetails',
                    params: {
                      bookId,
                      reportId,
                      reportDetailId: item.id
                    }
                  })
                })"
              >
                {{ $t('ebook.rate-report') }}
              </v-btn>

              <template v-else>
                <v-btn
                  class="elevation font-weight-bold d-flex align-center"
                  color="primary"
                  :style="{ height: '40px', justifyContent: 'center !important' }"
                  v-if="Lget(report, 'status', '') === 'notCertified' && Lget(item, 'instructorSkillEstimatedLevel', null)  !== null"
                  @click="$nextTick(() => { $router.push({ name: 'InstructorApprenticesReportDetails', params: {bookId: bookId, reportId: reportId, reportDetailId: item.id}})})"
                >
                  {{ $t('ebook.report-done') }}
                </v-btn>

                <v-icon
                  v-else
                  @click="$nextTick(() => { $router.push({ name: 'InstructorApprenticesReportDetails', params: {bookId: bookId, reportId: reportId, reportDetailId: item.id}})})"
                >
                  <template v-if="!edit">$sl-view</template>
                  <template v-else>$sl-edit</template>
                </v-icon>
              </template>
            </template>
          </v-list-item>
        </v-card>
      </v-list>

      <ActionButton type="application" actionIcon="$sl-add" v-if="edit" @click="modalClick" :isDisabled="isImitatingUser()">{{
        $t('ebook.add-elementpart')
      }}</ActionButton>

      <v-dialog persistent v-model="openModal" max-width="700px">
        <EbookElementModal
          :isInstructor="true"
          @close="modalClose"
          :currentReport="report"
          :show="show"
        ></EbookElementModal>
      </v-dialog>

      <!-- Report comment apprentice -->
      <h4 v-if="apprentice && apprentice.firstName" class="pt-7">{{ apprentice.firstName | filterGenitiveName }} {{ $t('ebook.comment') }}</h4>
      <p>{{ report.apprenticeComment || $t('ebook.no-comments') }}</p>

      <!-- Report comment Instructor -->
      <h4 v-if="report" class="pt-7">{{ $t('ebook.comment2') }}</h4>

      <v-textarea :disabled="!edit" v-model="report.instructorComment" outlined auto-grow rows="3"></v-textarea>

      <!-- Error info starts here -->
      <MessageBox class="mb-7 mt-5" type="info" v-if="apprentice && diffAssessment">
        <h6 class="pb-4 title text-uppercase">{{ $t('ebook.messagebox-title') }}</h6>
        <p>{{ $t('ebook.messagebox-text') }}</p>
      </MessageBox>

      <!-- modals component  -->
      <div v-if="edit && report && report.instructor && professionId && report.instructor.companyId">
        <SelectInstructorModal
          :companyId="report.instructor.companyId"
          :professionId="professionId"
          :instId="report.instructorId"
          :show="instructorModal"
          @close="instructorModalClose"
          @instructorCertified="instructorCertified"
        />
      </div>
      <div v-if="edit && report && report.instructor && report.instructor.companyId">
        <SelectWorkplaceModal
          :show="workplaceModal"
          :companyId="report.instructor.companyId"
          :workplace="report.workplace"
          @linked="linkWorkplace"
          @close="workplaceModal = false"
        />
      </div>

      <div v-if="showFromDateToDatePickerModal">
        <FromDateToDatePicker
          @close="closeFromDateToDatePickerModal"
          :fromDate="report.fromDate"
          :title="$t('ebook.change-period')"
          :toDate="report.toDate"
          @datesSelected="datesSelected"
        />
      </div>
      <template
        v-if="
          report && report.instructor && report.instructor.companyId && isInstructor(report.instructor.companyId) == true
        "
      >
        <ActionButton :isDisabled="dissSaveButton || !edit || isImitatingUser()" actionIcon="$sl-save" class="mt-6" @click="updateReport">{{
          saveButtonLabel
        }}</ActionButton>

        <ActionButton actionIcon="$sl-delete" class="mt-6" @click="showDeleteModal" :isDisabled="!edit || isImitatingUser()" type="application">{{
          $t('ebook.delete-report')
        }}</ActionButton>
      </template>
      <ActionButton class="mt-6" actionIcon="$sl-banned" type="application" @click="cancelReport">{{
        $t('labels.cancel')
      }}</ActionButton>
    </template>
    <ModalBase
        :show="showModal"
        maxWidth="400px"
        :title="$t('company.delete-report-title')"
        cancelIcon="$sl-cancel"
        submitIcon="$sl-delete"
        cancelText="Avbryt"
        submitText="Radera"
        @close="closeModal"
        @cancel="closeModal"
        @submit="deleteClick"
        :outlinedSubmit="true"
        :outlinedCancel="false">
        <template v-slot:text>
          {{$t('company.delete-report-text') }}
        </template>
    </ModalBase>
  </v-container>
</template>

<script>
import API from '@/services/api.js'
import EbookElementModal from '@/components/Ebook/Apprentice/EbookElementModal'
import SelectWorkplaceModal from '@/components/Common/SelectWorkplaceModal'
import SelectInstructorModal from '@/components/Common/SelectInstructorModal'
import FromDateToDatePicker from '@/components/Common/FromDateToDatePicker'
import GoBackAtTop from '@/components/Common/GoBackAtTop'
import ActionButton from '@/components/Common/ActionButton'
import {RulesMixin, InstructorAbilities} from '@/components/mixins'
import {mapActions, mapGetters} from 'vuex'
import MessageBox from '@/components/Common/MessageBox'
import ModalBase from '@/components/Common/ModalBase';
import ModalBaseMixin from "@/components/mixins/ModalBaseMixin";
const SugarDate = require('sugar/date')
const get = require('lodash').get
const compact = require('lodash').compact
import Lget from 'lodash/get'

// @group Ebook
// Styled ApprenticesReport component
export default {
  name: 'ApprenticesReport',

  mixins: [RulesMixin, ModalBaseMixin, InstructorAbilities],  

  components: {
    EbookElementModal,
    GoBackAtTop,
    ActionButton,
    SelectWorkplaceModal,
    SelectInstructorModal,
    FromDateToDatePicker,
    MessageBox,
    ModalBase,
  },
  data() {
    return {
      links: require('../../../lib/external-links.json'),
      shouldReadInstructions: true,
      instructorModal: false,
      workplaceModal: false,
      workplace: '',
      openModal: false,
      showFromDateToDatePickerModal: false,
      apprentice: {},
      report: {},
      AorIlevel: [],
      reportId: null,
      bookId: null,
      professionId: null,
      triggerWatch: false,
      show: '',
      instructorComment: '',
      edit: false
    }
  },
  watch: {
    $route() {
      this.init()
    },
    triggerWatch() {
      this.init()
    }
  },
  created() {
    this.init()
    this.getInstructions()
  },
  filters: {
    comment(val) {
      if (val && val.length > 44) {
        return val.substring(0, 44) + '...'
      } else return val
    },
    filterGenitiveName(name) {
      if (name && name.length > 0) {
        if (name.slice(-1) == 's') return name
      }
      return name + 's'
    }
  },
  computed: {
    ...mapGetters('currentuser', ['currentUser', 'isInstructor', 'isCompanyUser', 'isInstructorFor', 'isImitatingUser']),
    // @vuese
    // check if at least one of  apprenticeshipSkillEstimatedLevel &&  instructorSkillEstimatedLevel is diferent and display the error message
    diffAssessment() {
      if (!(this.report && this.report.reportDetails)) return
      let checkDiff = false
      this.report.reportDetails.forEach(e => {
        if (
          e.apprenticeshipSkillEstimatedLevel &&
          e.instructorSkillEstimatedLevel &&
          e.apprenticeshipSkillEstimatedLevel != e.instructorSkillEstimatedLevel
        ) {
          checkDiff = true
        }
      })
      return checkDiff
    },
    dissSaveButton() {
      if (!(this.report && this.report.reportDetails)) return
      let btn = false
      this.report.reportDetails.forEach(e => {
        if (!e.instructorSkillEstimatedLevel) {
          btn = true
        }
      })

      return btn
    },
    saveButtonLabel() {
      if (!(this.report && this.report.reportDetails)) return this.$t('labels.save-certify')
      const haveChangedLevels = this.report.reportDetails.some(report => {
        return (
          report.instructorSkillEstimatedLevel &&
          report.instructorSkillEstimatedLevel !== report.apprenticeshipSkillEstimatedLevel
        )
      })
      if (haveChangedLevels) return this.$t('labels.save-with-changes')
      return this.$t('labels.save-certify')
    },

    instructorBelongsToReport() {
      const employmentIds = compact(get(this, 'currentUser.employments', []).map(employment => employment.id || null))
      const instructorId = get(this, 'report.instructorId', null)
      const companyId = get(this, 'report.instructor.companyId', null)

      return this.isInstructor(companyId) && employmentIds.includes(instructorId)
    }
  },

  methods: {
    init() {
      //console.log("curr::", this.currentUser)
      if (this.currentUser && this.$route.params) {
        this.bookId = Number(this.$route.params.bookId)
        this.reportId = Number(this.$route.params.reportId)
        this.getReportById()
      }
    },
    
    currentUserIsInstructorFor(compId) {
      const roles = Lget(this, 'currentUser.companyRoles', []).filter((cr) => {
        return cr.companyId === compId && this.isInstructor(compId)
      })
      return Boolean(roles.length)
    },

    Lget: Lget,

    getInstructions() {
      API.getInstructions()
        .then(({data}) => {
          const commitedDate = data.committedAt
          const lastReadInstructions = this.currentUser.readInstructionsOn
          if (lastReadInstructions) {
            this.shouldReadInstructions = new SugarDate.Date(commitedDate).isAfter(lastReadInstructions).raw
          }          
        })
        .catch(error => {
          console.log('Error', error)
        })
    },
    // @vuese
    // Used get report by id
    // @arg The argument is an integer representing book and report id
    getReportById() {
      API.getReport(this.bookId, this.reportId)
        .then(res => {
          this.report = res.data
          if (
            res.data &&
            res.data.instructor &&
            res.data.instructor.companyId &&
            this.isCompanyUser(res.data.instructor.companyId) == true
          ) {
            this.getBookById()
            if (this.report.workplace && this.report.workplace.name) this.workplace = this.report.workplace.name

            if (this.report.workplace && this.report.workplace.postalCity)
              this.workplace += ' ' + this.report.workplace.postalCity

            const employmentIds = compact(get(this, 'currentUser.employments', []).map(employment => employment.id || null))
            const instructorId = get(this, 'report.instructorId', null)

            if (
              this.isInstructor(res.data.instructor.companyId) &&
              (!this.report.status ||
                this.report.status == '' ||
                this.report.status == 'draft' ||
                this.report.status == 'notCertified') &&
              employmentIds.includes(instructorId) 
            ) {
              this.edit = true
            }
          }
        })
        .catch(error => {
          console.log('There was an error:', error.response)
        })
    },
    // @vuese
    // Used get book by id
    // @arg The argument is an integer representing book
    getBookById() {
      API.getBook(this.bookId)
        .then(res => {
          this.professionId = res.data.professionId
          this.apprentice = res.data.person
        })
        .catch(error => {
          console.log('There was an error:', error.response)
        })
    },

    modalClick() {
      this.show = 'addElement'
      this.openModal = true
    },
    modalClose() {
      this.triggerWatch = !this.triggerWatch
      this.openModal = false
    },
    linkWorkplace(wp) {
      if (!wp || !(this.report && this.report.workplace)) {
        return
      }
      this.report.workplace = wp
      this.workplaceModal = false
      this.workplace = wp.name + ' ' + wp.postalCity
    },
    instructorCertified(newInstructor) {
      if (!newInstructor || !(this.report && this.report.instructor && this.report.instructor.employed)) {
        return
      }

      this.report.instructorId = newInstructor.id
      this.report.instructor.employed.firstName = newInstructor.firstName
      this.report.instructor.employed.lastName = newInstructor.lastName
      this.instructorModal = false
    },
    instructorModalClose(val) {
      this.instructorModal = false
    },
    // @vuese
    // Used get delete report
    // @arg The argument is an integer representing book id and report id
    deleteClick() {
      this.showModal = false;

      API.deleteReport(this.bookId, this.reportId)
          .then(response => {
            this.$events.fire('showInfo', this.$t('success.deleted'))

            return new Promise(resolve => {
              setTimeout(() => {
                this.$nextTick(() => {
                  this.$router.push({
                    name: 'InstructorApprenticesReports',
                    params: {id: this.currentUser.id, bookId: this.bookId}
                  })
                })
              }, 1000)
            })
          })
          .catch(error => {
            this.$events.fire('showError', this.$t('errors.delete-failure'))
            console.log('There was an error:', error)
          })
    },
    datesSelected(val) {
      this.report.fromDate = val.newFromdate
      this.report.toDate = val.newTodate
      this.showFromDateToDatePickerModal = false
    },
    closeFromDateToDatePickerModal(val) {
      this.showFromDateToDatePickerModal = false
    },
    openDates() {
      this.showFromDateToDatePickerModal = true
    },
    apprenticeOrInstructorLevel(r) {
      if (!r) return
      if (r.instructorSkillEstimatedLevel > 0 && r.instructorSkillEstimatedLevel !== null) {
        return r.instructorSkillEstimatedLevel
      } else {
        return r.apprenticeshipSkillEstimatedLevel
      }
    },
    checkIconLevel(r) {
      if (!r) return
      if (r.instructorSkillEstimatedLevel > 0 && r.instructorSkillEstimatedLevel !== null) {
        return '$sl-save-filled'
      }
    },
    // @vuese
    // Used get update report
    // @arg The argument is an integer representing book id ,report id and params is initReport
    updateReport() {

      const canApprove = this.canApproveEbook(this.professionId)
      if (!canApprove.result && canApprove.reason) {
        this.$events.fire("showError", canApprove.reason);
        return
      }

      if (!this.report) return
      let initReport = {
        fromDate: this.report.fromDate,
        toDate: this.report.toDate,
        workplaceId: this.report.workplace.id,
        instructorId: this.report.instructorId,
        instructorComment: this.report.instructorComment,
        changeStatus: true
      }

      API.updateReport(this.report.bookId, this.report.id, {
        data: initReport
      })
        .then(response => {
          this.triggerWatch = !this.triggerWatch
          this.instructorComment = ''
          this.$events.fire('showInfo', this.$t('success.saved'))
          this.$nextTick(() => {
            this.$router.push({
              name: 'InstructorApprenticesReports',
              params: {id: this.currentUser.id, bookId: this.bookId, showSelected: true}
            })
          })
        })
        .catch(error => {
          this.$events.fire('showError', this.$t('errors.save-failure'))
          console.log('Error: ' + error)
        })
    },
    cancelReport() {
      this.$nextTick(() => {
        this.$router.push({
          name: 'InstructorApprenticesReports',
          params: {id: this.currentUser.id, bookId: this.bookId}
        })
      })
    }
  }
}
</script>
